import { useEffect, useState } from 'react';
import { groupTripApi } from '../../api/groupTripApi';

// 僅從正式業務關聯查詢公開團名，不以家庭或兒童資料拼接名稱。
export default function useConversationTitles(conversations, memberId) {
  const [resolved, setResolved] = useState({});
  const ids = [...new Set(conversations.filter(row => row?.conversationType === 'BUSINESS_GROUP'
    && row.businessSystem === 'TRAVEL' && row.businessType === 'GROUP_TRIP'
    && /^[1-9]\d*$/.test(String(row.businessId || ''))).map(row => String(row.businessId)))].sort().join(',');
  useEffect(() => {
    let current = true;
    setResolved({});
    ids.split(',').filter(Boolean).forEach(id => {
      groupTripApi.getPublic(id).then(row => {
        if (!current || String(row?.groupTripId) !== id || typeof row?.recruitmentTitle !== 'string' || !row.recruitmentTitle.trim()) return;
        setResolved(old => ({ ...old, [id]: row.recruitmentTitle.trim() }));
      }).catch(() => { /* 查詢失敗沿用既有安全名稱。 */ });
    });
    return () => { current = false; };
  }, [ids, memberId]);
  return resolved;
}
